export default __webpack_public_path__ + "static/media/true jet logo.2e030ab0.png";